import { useListen, useIgnore } from '~/composables/useEventBus';

export function useEntityPreview(type: Ref<string>, id: Ref<string>) {
    const loading = ref(true);
    const error = ref(false);

    let debounceTimer: ReturnType<typeof setTimeout> | null = null;
    let refreshCallback: (() => Promise<void>) | null = null;

    const fetchEntity = async (callback: () => Promise<void>) => {
        loading.value = true;
        error.value = false;

        try {
            await callback();
        } catch {
            error.value = true;
        } finally {
            loading.value = false;
        }
    };

    const setRefreshCallback = (callback: () => Promise<void>) => {
        refreshCallback = callback;
    };

    const onEntityModified = (payload: { type: string; id: string }) => {
        if (payload.type !== type.value || payload.id !== id.value) return;
        if (!refreshCallback) return;

        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            if (refreshCallback) fetchEntity(refreshCallback);
        }, 500);
    };

    useListen('ai:entity-modified', onEntityModified);

    onBeforeUnmount(() => {
        useIgnore('ai:entity-modified', onEntityModified);
        if (debounceTimer) clearTimeout(debounceTimer);
    });

    return { loading, error, fetchEntity, setRefreshCallback };
}
